var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(11257 20416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_52c0c6bbd781735702c09a4d002d8f4a",
    "data-name": "52c0c6bbd781735702c09a4d002d8f4a",
    transform: "translate(-11255.313 -20414.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2065",
    "data-name": "Path 2065",
    d: "M22.218,12.133c-.115-.115-.115-.23-.23-.344L18.544,8.344a1.137,1.137,0,0,0-1.607,1.607l1.492,1.492H13.148A1.085,1.085,0,0,0,12,12.592a1.085,1.085,0,0,0,1.148,1.148h5.281l-1.492,1.492a1.11,1.11,0,0,0,0,1.607,1.11,1.11,0,0,0,1.607,0L21.988,13.4c.115-.115.23-.23.23-.344a1.268,1.268,0,0,0,0-.918Z",
    transform: "translate(-1.667 -2.26)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2066",
    "data-name": "Path 2066",
    d: "M17.351,20.336a8.377,8.377,0,0,1-4.018,1.033,8.036,8.036,0,1,1,0-16.073,8.377,8.377,0,0,1,4.018,1.033A1.182,1.182,0,1,0,18.5,4.263,11.445,11.445,0,0,0,13.333,3,10.333,10.333,0,1,0,18.5,22.287a1.271,1.271,0,0,0,.459-1.607A1.236,1.236,0,0,0,17.351,20.336Z",
    transform: "translate(-3 -3)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1059",
    "data-name": "Rectangle 1059",
    width: 24,
    height: 24,
    transform: "translate(-11257 -20416)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.9cdab6aec99744291e266e1d31910f91.svg";
export { ForwardRef as ReactComponent };